import {
  WS_CONNECT,
  WS_DISCONNECT,
  WS_MESSAGE_RECEIVED,
  WS_STATUS_CHANGED,
  WS_ERROR
} from './types'
import { updateStreamData } from './messageActions'
import { saveAnswer, updateChatSession } from './chatActions'

// WebSocket connection established
export const wsConnect = (sessionId, wsUrl) => ({
  type: WS_CONNECT,
  payload: { sessionId, wsUrl }
})

// WebSocket disconnected
export const wsDisconnect = (sessionId) => ({
  type: WS_DISCONNECT,
  payload: sessionId
})

// WebSocket status changed
export const wsStatusChanged = (status) => ({
  type: WS_STATUS_CHANGED,
  payload: status
})

// WebSocket error
export const wsError = (error) => ({
  type: WS_ERROR,
  payload: {
    message: error?.message || 'WebSocket connection error',
    code: error?.code || 'UNKNOWN_ERROR',
    timestamp: new Date().toISOString()
  }
})

// Process WebSocket message
export const wsMessageReceived = (data) => (dispatch, getState) => {
  console.log('📨 wsMessageReceived processing:', {
    phase: data.phase,
    payload: data.payload,
    payloadKeys: data.payload ? Object.keys(data.payload) : []
  })
  
  dispatch({
    type: WS_MESSAGE_RECEIVED,
    payload: data
  })
  
  // Handle different message phases
  const { phase, payload } = data
  
  if (phase === 'error') {
    dispatch(wsError(payload))
    return
  }
  
  // Update session title when we receive keywords (contains the query)
  if (phase === 'keywords' && payload.query) {
    const { activeSession } = getState().chat
    if (activeSession) {
      dispatch(updateChatSession(activeSession, {
        title: payload.query
      }))
    }
  }
  
  // Special handling for agent_progress
  if (phase === 'agent_progress') {
    const currentProgress = getState().messages.streamData.agent_progress || {}
    const newProgress = {
      ...currentProgress,
      [payload.agent]: payload
    }
    dispatch(updateStreamData('agent_progress', newProgress))
  } else {
    // Update stream data for other phases
    dispatch(updateStreamData(phase, payload))
  }
  
  // Handle final answer
  if (phase === 'final_answer') {
    const { activeSession } = getState().chat
    if (activeSession && payload.answer_id) {
      dispatch(saveAnswer(
        activeSession,
        payload.answer_id,
        getState().messages.streamData.keywords?.query || '',
        payload.answer_md,
        payload.citations
      ))
    }
  }
}